import React from 'react';

const linkMap = ({ input }) => {
  const map = input.map((e, i) => (
    <li key={i}>
      <a href={e.href} target="blank">
        {e.title}
      </a>
    </li>
  ));

  return <ul>{map}</ul>;
};

export default linkMap;



// WEBPACK FOOTER //
// ./src/Components/Tools/links.js